import React from "react";
import { Sv, ic } from "../../components/common/Icons";
import { ITA_NAV } from "../../data/itaData";
import SearchBar from "../../components/common/SearchBar";
import NotificationBell from "../../components/common/NotificationBell";
import "../../assets/styles/ITAdmin/ITATopbar.css";

function ITATopbar({ a, set, onLogout }) {
  return (
    <div className="TB">
      <div className="TB-bc">
        IT Admin <Sv d={ic.right} s={14} /> <b>{ITA_NAV.find((n) => n.k === a)?.l || "Dashboard"}</b>
      </div>
      <div className="itatopbar-inline-1">
        {/* Search */}
        <SearchBar portalName="IT Admin" resetKey={a} />

        {/* Chat */}
        <div className="TB-ib itatopbar-inline-2" onClick={() => set && set("chat")} title="Chat">
          <Sv d={ic.message} s={18} />
        </div>

        {/* Notification Bell — navigates directly to the relevant tab on click */}
        <NotificationBell onNavigate={(view) => set && set(view)} />

        {/* Logout */}
        <div className="TB-ib itatopbar-inline-20" onClick={onLogout} title="Sign Out">
          <Sv d={ic.logout} s={18} />
        </div>
      </div>
    </div>
  );
}

export default ITATopbar;
